/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  function registerInfiniteScrollLoadMoreButton() {
    const selectors = {
      loadMoreButton: ".js-load-more",
      totalPages: "[data-total-pages]",
      currentPage: "[data-current-page]",
      nextUrl: "[data-next-url]",
      loadMoreText: "[load-more-text]",
      loaderText: "[loader-text]",
      products: ".collection__products .grid-item.product-item.product-item-card:not(.product-grid-item-placeholder)",
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      totalProducts: ".total-products",
      nextCollection: "#NextCollection",
    };
  
    const hideClass = "hide";
    const loadMoreButton = document.querySelector(selectors.loadMoreButton);
    const nextCollection = document.querySelector(selectors.nextCollection);
    const currentProducts = document.querySelector(selectors.currentProducts);
    const totalProducts = document.querySelector(selectors.totalProducts);
    const totalPages = document.querySelector(selectors.totalPages);
  
    // Show "next-collection" if no Load More button or all products are already visible
    if (!loadMoreButton || (totalProducts && currentProducts && currentProducts.textContent === totalProducts.textContent)) {
      if (nextCollection) {
        // nextCollection.classList.remove("hidden"); // Disabled by Christian
      }
      return;
    }
  
    loadMoreButton.addEventListener("click", (e) => {
      const totalPagesValue = Number(totalPages.value);
      let currentPage = document.querySelector(selectors.currentPage);
      let currentPageValue = parseInt(currentPage.value);
      let nextUrl = document.querySelector(selectors.nextUrl);
  
      loadMoreButton.setAttribute("disabled", true);
  
      const loadMoreText = loadMoreButton.querySelector(selectors.loadMoreText);
      const loaderText = loadMoreButton.querySelector(selectors.loaderText);
  
      loadMoreText.classList.add(hideClass);
      loaderText.classList.remove(hideClass);
  
      fetch(nextUrl.value)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const products = doc.querySelectorAll(selectors.products);
          insertProducts(products);
  
          const newUrl = nextUrl.value;
  
          nextUrl.value = nextUrl.value.replace(
            `page=${currentPageValue + 1}`,
            `page=${currentPageValue + 2}`
          );
          currentPage.value = currentPageValue + 1;
  
          if (currentPage.value >= totalPagesValue) {
            loadMoreButton.classList.add(hideClass);
  
            if (currentProducts && totalProducts) {
              currentProducts.innerHTML = totalProducts.innerHTML;
            }
  
            // if (nextCollection) {
            //   nextCollection.classList.remove("hidden");
            // }
          }
  
          loadMoreButton.removeAttribute("disabled");
          loadMoreText.classList.remove(hideClass);
          loaderText.classList.add(hideClass);
  
          window.history.pushState(
            {
              param: Shopify.queryParams,
            },
            document.title,
            newUrl
          );
        })
        .catch((error) => {
          console.warn("Loading more products failed", error);
          loadMoreButton.classList.add(hideClass);
        });
    });
  }

  function insertProducts(products, before = false) {
    const selectors = {
      productGrid: "div[data-products-grid] .grid",
      currentProducts: ".current-products",
      productCard: ".grid-item.product-item.product-item-card:not(.product-grid-item-placeholder)"
    };

    const productGrid = document.querySelector(selectors.productGrid);

    products.forEach((product) => {
      if (before) {
        productGrid.prepend(product);
      } else {
        productGrid.appendChild(product);
      }
    });

    const currentProducts = document.querySelector(selectors.currentProducts);
    currentProducts.innerHTML = productGrid.querySelectorAll(selectors.productCard).length;
  }

  registerInfiniteScrollLoadMoreButton();

  // Add a data attribute with the current currency rate to the body
  document.body.dataset.currencyRate = Shopify.currency.rate;

  function validateCart(cart) {
    validateGifts(cart);
  }

  function validateGifts(cart) {
    // If the cart only has 1 item, and it is an item with "product_title" equal to "Thank you for shopping", remove it
    if (cart.item_count === 1) {
      const item = cart.items[0];
      if (item.product_title === "Thank you for shopping") {
        console.log("Cart has only one item, which is a gift, removing it");

        fetch(`/cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0,
          }),
        })
        .then((response) => response.json())
        .then((data) => {
          console.log("Gift removed from cart:", data);
        })
        .catch((error) => {
          console.error("Error removing gift from cart:", error);
        });
      }
    }
  }

  document.addEventListener('rebuy:smartcart.ready', (event) => {
    validateCart(event.detail.smartcart.cart);
  });

  document.addEventListener('rebuy:cart.change', (event) => {
    validateCart(event.detail.cart.cart);
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

function initRebuyCart() {
  document.addEventListener('rebuy:smartcart.ready', (event) => {
    adjustRebuyContent();
    runRebuyCode(event.detail.smartcart.cart);
    replaceProgressStepIcons(); 
  });

  document.addEventListener('rebuy:cart.change', (event) => {
    const cart = event.detail.cart.cart;
    runRebuyCode(cart);  
    replaceProgressStepIcons(); 
  });
}

function replaceProgressStepIcons() {
  const shippingIcon = 'https://essentialfoods-shop.myshopify.com/cdn/shop/files/shipping.png';  
  const giftCardIcon = 'https://essentialfoods-shop.myshopify.com/cdn/shop/files/giftcard-progressbar.png'; 

  const progressIcons = document.querySelectorAll('.rebuy-cart__progress-step-icon');

  progressIcons.forEach((icon) => {
    const stepLabel = icon.parentElement.querySelector('.rebuy-cart__progress-step-label');
    const progressStep = icon.parentElement;  
    
    let customIcon = '';
    const shippingLabels = ['SHIPPING', 'FRAKT', 'FRAGT', 'VERSAND'];
    const giftCardLabels = ['GIFT', 'GAVE', 'GÅVA', 'GESCHENK'];
    if (stepLabel && shippingLabels.some(_ => stepLabel.textContent.includes(_))) {
      customIcon = shippingIcon;
    } 
    else if (stepLabel && giftCardLabels.some(_ => giftCardLabels.includes(_))) {
      customIcon = giftCardIcon;
    }

    icon.style.width = '30px';
    icon.style.height = '30px';
    icon.style.backgroundImage = `url(${customIcon})`;
    icon.style.backgroundSize = 'contain';
    icon.style.backgroundRepeat = 'no-repeat';
    icon.style.backgroundPosition = 'center';

    const svgRebuy = icon.querySelector('svg');
    if (svgRebuy) {
      svgRebuy.style.display = 'none';  
    }

    if (progressStep.classList.contains('complete')) {
      icon.classList.add('custom-complete');
    } else {
      icon.classList.remove('custom-complete');
    }

    icon.innerHTML = '';
  });
}

const cartFooterTranslations = {
  en: {
    shipping: 'Shipping',
    subtotal: 'Subtotal',
    items: 'items',
    item: 'item',
    free: 'Free',
  },
  da: {
    shipping: 'Fragt',
    subtotal: 'Subtotal',
    items: 'produkter',
    item: 'produkt',
    free: 'Gratis',
  },
  sv: {
    shipping: 'Frakt',
    subtotal: 'Delsumma',
    items: 'produkter',
    item: 'produkt',
    free: 'Gratis',
  },
  no: {
    shipping: 'Frakt',
    subtotal: 'Delsum',
    items: 'produkter',
    item: 'produkt',
    free: 'Gratis',
  },
  de: {
    shipping: 'Versand',
    subtotal: 'Zwischensumme',
    items: 'Artikel',
    item: 'Artikel',
    free: 'Kostenlos',
  }  
}

function runRebuyCode(cart) {
  const isB2b = window.theme.b2b?.isEnabled;
  const locale = Shopify?.locale;
  const translation = cartFooterTranslations[locale] ?? cartFooterTranslations.en;
  const rebuyFooter = document.querySelector('div[data-rebuy-cart-anchor="footer"]');

  if (!rebuyFooter) {
    return;
  }

  if (cart.item_count === 0) {
    rebuyFooter.style.display = 'none'; 
    return; 
  } else {
    rebuyFooter.style.display = 'flex';
  }

  const subtotalPrice = cart.items_subtotal_price;
  const marketHandle = window.theme?.settings.marketHandle;
  const deliveryLimitSetting = window.theme?.settings[`freeShippingLimit_${marketHandle}`];
  const deliveryPriceSetting = window.theme?.settings[`shippingPrice_${marketHandle}`];

  let deliveryPrice = deliveryPriceSetting ? Number(deliveryPriceSetting.replace(",", ".") * 100) : null;
  const deliveryLimit = deliveryLimitSetting ? Number(deliveryLimitSetting * 100) : null;

  if (!deliveryPrice || !deliveryLimit) { 
    return;
  }

  if (subtotalPrice > deliveryLimit) {
    deliveryPrice = 0;
  }

  let footerDetails = rebuyFooter.querySelector('.footer-details');
  let estimatedDelivery

  if (!footerDetails) {
    footerDetails = document.createElement('div');
    footerDetails.classList.add('footer-details');
    rebuyFooter.appendChild(footerDetails);
  } else {
    estimatedDelivery = footerDetails.querySelector('.estimated-delivery');
    footerDetails.innerHTML = '';
  }

  // Create subtotal line
  const subtotalLine = document.createElement('div');
  subtotalLine.classList.add('footer-details__line');

  const subtotalLeft = document.createElement('div');
  subtotalLeft.textContent = `${translation.subtotal} (${cart.item_count} ${cart.item_count > 1 ? translation.items : translation.item})`;

  const subtotalRight = document.createElement('div');
  subtotalRight.textContent = formatMoney(subtotalPrice);
  subtotalLine.appendChild(subtotalLeft);
  subtotalLine.appendChild(subtotalRight);
  footerDetails.appendChild(subtotalLine);

  // Create delivery line
  const deliveryLine = document.createElement('div');
  deliveryLine.classList.add('footer-details__line');

  const deliveryLeft = document.createElement('div');
  deliveryLeft.textContent = translation.shipping;

  const deliveryRight = document.createElement('div');

  if (deliveryPrice === 0) {
    deliveryRight.textContent = translation.free;
  } else {
    deliveryRight.textContent = formatMoney(deliveryPrice);
  }

  deliveryLine.appendChild(deliveryLeft);
  deliveryLine.appendChild(deliveryRight);
  footerDetails.appendChild(deliveryLine);

  const totalLine = rebuyFooter.querySelector('.rebuy-cart__flyout-subtotal-amount');

  if (totalLine) {
    let totalAmount = subtotalPrice;
    totalAmount += deliveryPrice;
    totalLine.textContent = formatMoney(totalAmount);
  }

  if (estimatedDelivery && footerDetails) {
    if (!footerDetails.contains(estimatedDelivery)) {
      footerDetails.appendChild(estimatedDelivery);
    }
  }
}

function formatMoney(amount) {
  const currency = Shopify.currency.active; 
  const formattedAmount = (amount / 100).toFixed(2).replace('.', ',');
  return `${currency} ${formattedAmount}`;
}

function adjustRebuyContent() {
  setTimeout(() => {
    const paymentIcons = document.querySelector('.cart__drawer__payment__icons');
    const checkoutArea = document.querySelector('div[data-rebuy-component="checkout-area"]');
    const estimatedDelivery = document.querySelector('.estimated-delivery');
    const footerContainer = document.querySelector('div[data-rebuy-cart-anchor="footer"]');
    const footerDetails = footerContainer?.querySelector('.footer-details');

    if (paymentIcons && checkoutArea && !footerContainer.contains(paymentIcons)) {
      const clonedPaymentIcons = paymentIcons.cloneNode(true);
      checkoutArea.appendChild(clonedPaymentIcons);
    }

    if (estimatedDelivery && footerContainer && footerDetails) {
      if (!footerDetails.contains(estimatedDelivery)) {
        if (!window.theme.b2b?.isEnabled) {
          footerDetails.appendChild(estimatedDelivery); 
        }        
      }
    }
  }, 500);
}

initRebuyCart();


async function addPreviousCollectionProducts() {
  const selectors = {
    products: ".grid-item.product-item.product-item-card",
    productGrid: "div[data-products-grid] .grid",
  };

  const previousProductDivs = document.querySelectorAll('.js-collection-previous-products');
  const reversedPreviousProductDivs = Array.from(previousProductDivs);
  const previousProducts = [];

  const promises = reversedPreviousProductDivs.map(div => {
    const url = div.getAttribute('data-url');
    return fetch(url).then(response => response.text());
  });

  const responses = await Promise.all(promises);

  responses.forEach((html, index) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const products = doc.querySelectorAll(selectors.products);
    previousProducts.push(...products);
  });

  const productGrid = document.querySelector(selectors.productGrid);
  const placeholders = [...document.querySelectorAll('.product-grid-item-placeholder')];

  previousProducts.reverse().forEach((product, index) => {
    if (placeholders[index]) {
      placeholders[index].outerHTML = product.outerHTML;
    } else {
      productGrid.prepend(product);
    }
  });

  placeholders.slice(previousProducts.length).forEach(placeholder => placeholder.remove());
}

(async function () {
  await addPreviousCollectionProducts();
})();

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

// Select the header element
const header = document.querySelector('.theme__header');

// Add a scroll event listener to monitor the header's state
window.addEventListener('scroll', () => {
  if (!header) return;

  const isStuck = header.classList.contains('js__header__stuck');
  const isTransparent = header.hasAttribute('data-header-transparent');

  // Add the 'has-border' class if header is stuck and remove it if transparent
  if (isStuck && !isTransparent) {
    header.classList.add('has-border'); // Ensure border is applied only when stuck
  } else {
    header.classList.remove('has-border'); // Remove border if it's transparent or not stuck
  }
});  

function injectRechargeStyles(widget) {
  if (!widget.shadowRoot) {
    console.warn('Cannot inject styles: shadowRoot is not open or not ready.');
    return;
  }

  // Only inject once per widget
  const existing = widget.shadowRoot.querySelector('#myCustomStyles');
  if (!existing) {
    const styleEl = document.createElement('style');
    styleEl.id = 'myCustomStyles';
    styleEl.textContent = `
      .rc-purchase-option {
        background-color: transparent !important;
        border: none !important;
      }

      .rc-price.strike-through.text-muted {
        color: rgba(32, 43, 33, 0.6) !important;
        font-weight: 400 !important;
      }

      .rc-price {
        color: var(--web-green-dark) !important;
        font-weight: 500 !important;
      }

      .rc-selection__root {
        border: 1px solid var(--soapstone) !important;
        padding: 15px 20px !important;
        margin-bottom: 15px !important;
      }

      .rc-purchase-option:hover {
        background-color: transparent !important;
      }

      .rc-purchase-option.rc-selection__onetime {
        border-bottom: 1px solid #ECE4D5 !important;
        padding-bottom: 15px !important;
      }

      .rc-purchase-option__sub-container {
        padding: 0 !important;
      }

      .rc-purchase-option.rc-purchase-option__subscription .rc-purchase-option__label {
        margin-bottom: 15px !important;
      }

      .rc-purchase-option__sub-container {
        gap: 15px !important;
      }

      .rc-purchase-option__prices {
        margin-left: 0 !important;
      }

      .rc-purchase-option__selector {
        font-size: var(--font-3) !important;
        font-weight: 500 !important;
        text-transform: uppercase !important;
        gap: 10px !important;
        color: var(--web-green-dark) !important;
      }

      .rc-purchase-option__checked-indicator {
        margin-right: 0 !important;
      }

      rc-learn-more {
        margin-left: 0 !important;
      }

      .rc-purchase-option__prices {
        flex-direction: row !important;
        gap: 5px !important;
      }

      .rc-purchase-option__selector {
        padding: 0 !important;        
      }

      .rc-purchase-option__label {
        padding: 0 !important;  
      }

      @media (max-width: 749px) {
        .rc-selection__root {
          padding-top: 15px !important;
          padding-bottom: 20px !important; 
          padding-left: 15px !important;
          padding-right: 15px !important;
        }
      }
    `;
    widget.shadowRoot.appendChild(styleEl);
  }

  // Handle nested Shadow DOM for rc-learn-more
  const learnMore = widget.shadowRoot.querySelector('rc-learn-more');
  if (learnMore && learnMore.shadowRoot) {
    const nestedStyleEl = learnMore.shadowRoot.querySelector('#nestedCustomStyles') || document.createElement('style');
    nestedStyleEl.id = 'nestedCustomStyles';
    nestedStyleEl.textContent = `
      .rc-learn-more__trigger {
        background-color: transparent !important;
        color: var(--web-green) !important;
        width: 17px !important;
        height: 17px !important;
      }

      .rc-learn-more__trigger svg {
        fill: var(--web-green) !important; 
        width: 17px !important;
        height: 17px !important;
      }
    `;
    if (!learnMore.shadowRoot.querySelector('#nestedCustomStyles')) {
      learnMore.shadowRoot.appendChild(nestedStyleEl);
    }
  }

  // Handle nested Shadow DOM for rc-radio-icon
  const radioIcons = widget.shadowRoot.querySelectorAll('rc-radio-icon');
  radioIcons.forEach((icon) => {
    if (icon.shadowRoot) {
      const radioIconStyleEl = icon.shadowRoot.querySelector('#radioIconCustomStyles') || document.createElement('style');
      radioIconStyleEl.id = 'radioIconCustomStyles';
      radioIconStyleEl.textContent = `
        svg.rc-unchecked-icon {
          stroke: var(--soapstone) !important; 
          width: 20px !important;
          height: 20px !important;
        }

        svg.rc-unchecked-icon rect {
          stroke: var(--soapstone) !important;
        }

        svg.rc-checked-icon {
          width: 20px !important;
          height: 20px !important;
        }

        svg.rc-checked-icon rect {
          stroke: var(--sage) !important;
        }

        svg.rc-checked-icon circle {
          fill: var(--web-green) !important; 
        }
      `;
      if (!icon.shadowRoot.querySelector('#radioIconCustomStyles')) {
        icon.shadowRoot.appendChild(radioIconStyleEl);
      }
    }
  });


  // Handle nested Shadow DOM for rc-benefits
  const benefits = widget.shadowRoot.querySelector('rc-benefits');
  if (benefits && benefits.shadowRoot) {
    const benefitsStyleEl = benefits.shadowRoot.querySelector('#benefitsCustomStyles') || document.createElement('style');
    benefitsStyleEl.id = 'benefitsCustomStyles';
    benefitsStyleEl.textContent = `
      ul {
      list-style: none; 
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    ul li {
      position: relative;
      padding-left: 16px; 
      font-size: var(--font-3);
      color: #000000;
      line-height: normal !important;
    }

    ul li::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 7.5px; 
      height: 8px; 
      mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='10' viewBox='0 0 9 10' fill='none'%3E%3Cpath d='M1 5L4.5 8.5L8.5 0.5' stroke='%23D9AB57' stroke-linecap='round'/%3E%3C/svg%3E");
      mask-size: contain; 
      mask-position: center; 
      mask-repeat: no-repeat; 
      background-color: #D9AB57;
    }

    `;

    if (!benefits.shadowRoot.querySelector('#benefitsCustomStyles')) {
      benefits.shadowRoot.appendChild(benefitsStyleEl);
    }
  }


  // Handle nested Shadow DOM for rc-selling-plans
  const sellingPlans = widget.shadowRoot.querySelector('rc-selling-plans');
  if (sellingPlans && sellingPlans.shadowRoot) {
    const sellingPlansStyleEl = sellingPlans.shadowRoot.querySelector('#sellingPlansCustomStyles') || document.createElement('style');

    if (sellingPlansStyleEl) {
      sellingPlansStyleEl.id = 'sellingPlansCustomStyles';
      sellingPlansStyleEl.textContent = `
        .rc-plans-dropdown__select {
          padding: 12px 15px !important;
          border: 1px solid var(--sage) !important;
          color: var(--web-green-dark) !important;
          font-size: var(--font-3) !important;
          font-family: var(--FONT-STACK-BODY) !important;
          cursor: pointer !important;
          border-radius: 0 !important;
        }

        select:focus-visible {
          box-shadow: none !important;
        }

        .rc-plans-dropdown__icon {
          color: rgba(32, 43, 33, 0.6) !important;
          width: 18px !important;
          height: 18px !important;
        }

          @media (max-width: 749px) {
            .rc-plans-dropdown__select {
              padding: 10px 15px !important;
          }
        }
      `;
      
      if (!sellingPlans.shadowRoot.querySelector('#sellingPlansCustomStyles')) {
        sellingPlans.shadowRoot.appendChild(sellingPlansStyleEl);
      }
    }
  }

  
   // Selected subscription option
   const selectedOption = widget.shadowRoot.querySelector('.rc-purchase-option[rc-selected]');

    if (!selectedOption) {
      return;
    }

    // Price within the selected option
    const priceElement = selectedOption.querySelector('.rc-price:not(.strike-through)');
    if (!priceElement) {
      return;
    }

    // Extract the actual price, ignoring the "visually-hidden" span
    const price = Array.from(priceElement.childNodes)
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .map((node) => node.textContent.trim())
      .join('');

    const addToCartButtonPrice = document.querySelector('button[data-add-to-cart] .btn__text__price');
    if (addToCartButtonPrice) {
      addToCartButtonPrice.textContent = price;
    } else {
      console.warn('Add to Cart button price wrapper not found.');
    }

    const addToCartButton = document.querySelector('button[data-add-to-cart]');
    const isSubscription = selectedOption.classList.contains('rc-purchase-option__subscription');
    const buttonText = addToCartButton.querySelector('.btn__text');
    if (buttonText) {
      if (isSubscription) {
        buttonText.textContent = window.theme.strings.subscribe;
      } else {
        buttonText.textContent = window.theme.strings.addToCart;
      }
    }
}

function observeRechargeWidget() {
  const observer = new MutationObserver(() => {
    // Grab the widget if it exists
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget) return;

    widget.style.display = 'none';

    if (widget.shadowRoot && widget.shadowRoot.querySelector('.rc-purchase-option')) {
      injectRechargeStyles(widget);

      widget.style.display = '';

      // // Observe changes within rc-radio-icon components
      // const radioIcons = widget.shadowRoot.querySelectorAll('rc-radio-icon');
      // radioIcons.forEach((icon) => {
      //   const iconObserver = new MutationObserver(() => {
      //     injectRechargeStyles(widget); 
      //   });
      //   iconObserver.observe(icon.shadowRoot, { childList: true, subtree: true });
      // });

      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

observeRechargeWidget();

(function () {
  async function loadAllProducts() {
    const templateSuffix = "json-bb";
    const collectionHandle = "all";

    const response = await fetch(
      `/collections/${collectionHandle}?view=${templateSuffix}`,
      {
        type: "GET",
      }
    );

    const json = await response.json();
    window.ALL_VARIANTS = json.products;
  }

  loadAllProducts().then(() => {
    // console.log("VARIANTS LOADED: ", window.ALL_VARIANTS);
  });
})();

function removeUnrestrictedProducts() { 
  const restrictedIds = window.theme.b2b?.customer.restrictedProductIds;

  document.querySelectorAll('[data-product-id]').forEach(element => {
    if (element.classList.contains("bundle-builder-cart__item")) {
      return;
    }
    const productId = parseInt(element.dataset.productId, 10).toString();
    if (!restrictedIds.includes(productId)) {
      element.remove();
    }
  });
}

function lockRestrictedProducts() {
  const restrictedIds = window.theme.b2b?.customer.restrictedProductIds;
  
  if (window.location.pathname.includes('/products/')) {
    const productElement = document.querySelector('[data-product-id]');
    if (productElement) {
      const productId = parseInt(productElement.dataset.productId, 10).toString();
      if (!restrictedIds.includes(productId)) {
        window.location.href = '/';
        return;
      }
    }
  }
}

(function () {
  if (window.theme.b2b.isEnabled && window.theme.b2b.customer.restrictedProductIds.length > 0) {
    lockRestrictedProducts();
    removeUnrestrictedProducts();   

    // Every 500ms run the removeUnrestrictedProducts function
    setInterval(removeUnrestrictedProducts, 200);
  }
})();

function hideCollectionProductCount() {
  if (window.theme.b2b?.isEnabled) {
    const collectionProductCount = document.querySelector('.collection__product-count');
    
    if (collectionProductCount) {
      collectionProductCount.style.display = 'none';
    }
  }
}

hideCollectionProductCount();

function countrySelector() {
  const countryLinks = document.querySelectorAll(".country-selector__link");

  countryLinks.forEach(link => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const countryUrl = this.getAttribute("href");

      if (countryUrl) {
        window.location.href = countryUrl;
      }
    });
  });
} 
countrySelector(); 